import { useTLang } from 'intl/intl';

export function useSOAlertDetailLang() {
  return {
    alertText: useTLang({ id: 'scheduleOrder.detail.alertText' }),
  };
}
